import React from 'react';
import { Carousel } from '@mantine/carousel';
import { ReactComponent as CheckIcon } from "assets/verified.svg";
import styles from './FilterCarousel.module.scss';

interface FilterCarouselProps {
  selectedFilter: string;
  onFilterChange: (filter: string) => void;
}

const FilterCarousel: React.FC<FilterCarouselProps> = ({ selectedFilter, onFilterChange }) => {
  const filters = ['All', 'Geo-Verified', 'Direct', 'Badger Exported', 'Distributor',];

  return (
    <div className={styles.carouselWrapper}>
      <Carousel
        slideSize="auto"
        slideGap="md"
        withControls={false}
        withIndicators={false}
        height={50}
        emblaOptions={{ 
          align: 'start', 
          slidesToScroll: 1,
          containScroll: 'trimSnaps',
          loop: false
        }}
        styles={{
          control: {
            '&[data-inactive]': {
              opacity: 0,
              cursor: 'default',
            },
          },
          root: {
            display: 'flex',
            flexDirection: 'row',
          },
          viewport: {
            display: 'flex',
            flexDirection: 'row',
          },
        }}
      >
        {filters.map((filter) => (
          <Carousel.Slide key={filter}>
            <div 
              className={`${styles.filterCard} ${selectedFilter === filter ? styles.selected : ''}`}
              onClick={() => onFilterChange(filter)}
            >
              {selectedFilter === filter && filter === "Geo-Verified" && (
                <CheckIcon className={styles.checkIcon} />
              )}
              {filter}
            </div>
          </Carousel.Slide>
        ))}
      </Carousel>
    </div>
  );
};

export default FilterCarousel; 